import React, { useState } from 'react';
import { Box, TextField, Typography, Button, IconButton, Paper, Alert } from '@mui/material';
import { Add as AddIcon, Delete as DeleteIcon } from '@mui/icons-material';

import { PresetBatchEditorProps } from '../types';

export const PresetBatchEditor: React.FC<PresetBatchEditorProps> = ({ batch, onChange }) => {
  const [newFieldKey, setNewFieldKey] = useState('');
  const [newFieldValue, setNewFieldValue] = useState('');

  const addField = () => {
    if (newFieldKey) {
      onChange({
        ...batch,
        fields: {
          ...batch.fields,
          [newFieldKey]: newFieldValue,
        },
      });
      setNewFieldKey('');
      setNewFieldValue('');
    }
  };

  const removeField = (key: string) => {
    const { [key]: removed, ...rest } = batch.fields || {};
    onChange({ ...batch, fields: rest });
  };

  return (
    <Box>
      <Alert severity="info" sx={{ mb: 2 }}>
        <Typography variant="body2">
          <strong>Preset Batch:</strong> Set form fields immediately with static values
        </Typography>
      </Alert>

      <Typography variant="subtitle2" gutterBottom>
        Fields to Set
      </Typography>

      {/* Existing fields */}
      {Object.entries(batch.fields || {}).map(([key, value]) => (
        <Paper key={key} sx={{ p: 2, mb: 1, display: 'flex', alignItems: 'center', gap: 2 }}>
          <TextField
            size="small"
            value={key}
            onChange={(e) => {
              const newFields = { ...batch.fields };
              delete newFields[key];
              newFields[e.target.value] = value;
              onChange({ ...batch, fields: newFields });
            }}
            label="Field Name"
          />
          <TextField
            size="small"
            fullWidth
            value={typeof value === 'string' ? value : JSON.stringify(value)}
            onChange={(e) => {
              onChange({
                ...batch,
                fields: {
                  ...batch.fields,
                  [key]: e.target.value,
                },
              });
            }}
            label="Field Value"
            placeholder="Static value or JSON"
          />
          <IconButton onClick={() => removeField(key)} color="error">
            <DeleteIcon />
          </IconButton>
        </Paper>
      ))}

      {/* Add new field */}
      <Paper sx={{ p: 2, display: 'flex', alignItems: 'center', gap: 2 }}>
        <TextField
          size="small"
          value={newFieldKey}
          onChange={(e) => setNewFieldKey(e.target.value)}
          label="Field Name"
          placeholder="privacy, sorting, etc."
        />
        <TextField
          size="small"
          fullWidth
          value={newFieldValue}
          onChange={(e) => setNewFieldValue(e.target.value)}
          label="Field Value"
          placeholder="public, 1, true"
        />
        <Button onClick={addField} startIcon={<AddIcon />}>
          Add
        </Button>
      </Paper>
    </Box>
  );
};
